//**************************************************************
// 1. scroll fadein animation
//**************************************************************
$(window).scroll(function () {
  $('.fadeInUp').each(function() {
    var elemPos = $(this).offset().top,
      scroll = $(window).scrollTop(),
      windowHeight = $(window).height();

    if (scroll > elemPos - windowHeight + 100) {
      $(this).addClass('scrollin');
    }
  });
});


//**************************************************************
// 2. Scroll ※topを離れたらclass付与
//**************************************************************
function init() {
  // スクロールして何ピクセルでアニメーションさせるか
  var px_change   = 300;

  // スクロールのイベントハンドラを登録　ヘッダーにクラス名 smaller を付与
  window.addEventListener('scroll', function(e){
    // 変化するポイントまでスクロールしたらクラスを追加
    if ( $(window).scrollTop() > px_change ) {
      $('header').addClass('smaller');

    // 変化するポイント以前であればクラスを削除
    } else if ( $('header').hasClass('smaller') ) {
      $('header').removeClass('smaller');
      $('#header-nav').removeAttr('checked').prop('checked', false).change();  // topでpull down用のcheckを外す
    }
  });
}
window.onload = init();

//**************************************************************
// 2. Smooth Scroll （TOPに戻るボタン用）
//**************************************************************
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, 'linear');
    return false;
  });
});


// import smoothscroll from "smoothscroll-polyfill";
//
// // kick off the polyfill!
// smoothscroll.polyfill();
//
// document.addEventListener("click", e => {
//   const target = e.target;
//   // clickした要素がclass属性、js-smooth-scrollを含まない場合は処理を中断
//   if (!target.classList.contains("js-smooth-scroll")) return;
//   e.preventDefault();
//   const targetId = target.hash;
//   const targetElement = document.querySelector(targetId);
//   // 画面上部から要素までの距離
//   const rectTop = targetElement.getBoundingClientRect().top;
//   // 現在のスクロール距離
//   const offsetTop = window.pageYOffset;
//   // スクロール位置に持たせるバッファ
//   const buffer = 50;
//   const top = rectTop + offsetTop - buffer;
//
//   window.scrollTo({
//     top,
//     behavior: "smooth"
//   });
// });


//**********************************************************************
// Twitter・instagramの遅延読み込み
//**********************************************************************
function twitterLazyLoad(src) {

    const scriptTag = document.createElement('script');
    scriptTag.src = src;
    scriptTag.async = true;

    document.body.appendChild(scriptTag);
}

function doTwitterLazyLoad() {

    const twitterEmbed = document.getElementsByClassName('twitter-tweet');
    const instaEmbed = document.getElementsByClassName('instagram-media');
    try {
        if (twitterEmbed.length !== 0) twitterLazyLoad('https://platform.twitter.com/widgets.js');
        if (instaEmbed.length !== 0) twitterLazyLoad('//www.instagram.com/embed.js');
    } catch (error) {
        console.log(error);
    }
}
window.addEventListener('scroll', doTwitterLazyLoad, { once: true });
